import React from "react";
import { packClasses } from "Utils";

export default function SecondaryButton({
    label,
    className,
    type,
    children,
    variant,
    ...remainder
}) {
    return (
        <button
            type={type ? type : "button"}
            className={packClasses(
                "focus:outline-none rounded-md border border-gray-300 bg-white font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:ring-2 focus:ring-green-500 focus:ring-offset-2 disabled:opacity-50",
                className ? className : "",
                variant === "xs" ? "py-1 px-2 text-xs" : "py-2 px-4 text-sm"
            )}
            {...remainder}
        >
            {children ? children : label}
        </button>
    );
}
